/* eslint-disable @typescript-eslint/member-ordering */
import BaseViewService from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-service';
import { IRightSideBarProps, IRightSideBarService } from './interface';
import RightSideBarModel from './model';
import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { RightSideBarModule } from './right-side-bar-module';

export default class RightSideBarService extends BaseViewService<IRightSideBarProps> implements IRightSideBarService {
    private modules: RightSideBarModule[] = [];
    private visibleModule;
    private beforeShowCallback = () => {};
    private afterHideCallback: () => void;

    constructor() {
        super();
    }

    /**
     * register module
     * @param {module} m
     */
    public registerModule(m: RightSideBarModule) {
        // duplicate module
        const existModule = this.modules.filter(mo => mo.name === m.name);
        if (existModule.length > 0) {
            return;
        }
        this.modules.push(m);
        this.refresh();
    }

    /**
     * show a module with name
     * @param {module name} name
     * @param {extra parameters} param
     */
    public show(name, param) {
        const m = this.getModule(name);
        if (!m) {
            // no valid module
            return;
        }
        this.beforeShowCallback?.();
        // if a module exists, hide it
        if (this.visibleModule) {
            this.visibleModule.hide();
            this.resetWidth();
        }
        // set visible module
        this.visibleModule = m;
        // show
        m.show(param);
    }

    public isShown(name) {
        const module = this.getModule(name);
        if (!module) {
            // no valid module
            return false;
        }
        if (this.visibleModule === module) {
            return true;
        }
        return false;
    }

    /**
     * hide right side bar
     */
    public hide() {
        // if a module exists, hide it, hide container until hide animation finished
        if (this.visibleModule) {
            this.visibleModule.hide();
        } else { // else hide container
            this.hideContainer();
            this.visibleModule = null;
        }
        this.afterHideCallback?.();
    }

    /**
     * get the module with name
     * @param {module name} name
     */
    public getModule(name) {
        return this.modules.find(rsm => rsm.name === name);
    }

    public getModules() {
        return this.modules;
    }

    // 获取当前正在显示的module
    public getVisibleModule(): RightSideBarModule {
        return this.visibleModule;
    }

    /**
     * check the module is visible in right side bar
     * @param {module} m
     */
    public _isModuleVisible(m: RightSideBarModule) {
        return this.visibleModule === m;
    }

    /**
     * get the name of module that displaying
     */
    public displayingModuleName() {
        return this.visibleModule?.name;
    }

    public setWidth(width) {
        this._setWidth(width);
    }

    public resetWidth() {
        this._resetWidth();
    }

    public registerCallback(callbackList) {
        this.beforeShowCallback = callbackList?.beforeShow ?? null;
        this.afterHideCallback = callbackList?.afterHide ?? null;
    }

    public _setWidth(width) {
        this.updateModel<RightSideBarModel>({
            width,
        });
    }

    public _resetWidth() {
        this._setWidth(null);
    }

    /**
     * show container
     */
    public showContainer() {
        this.updateModel<RightSideBarModel>({
            visible: true,
        });
    }

    /**
     * hide container
     */
    public hideContainer() {
        this.updateModel<RightSideBarModel>({
            visible: false,
        });
    }

    /**
     * refresh container
     */
    public refresh() {
        this.updateModel<RightSideBarModel>({});
    }

    /**
     * call before a module shown
     * @param {module} m
     */
    public onModuleWillShow(m: RightSideBarModule) {
        m.wrapperWillShow();
        this.showContainer();
    }

    /**
     * call after a module hidden
     * @param {module} m
     */
    public onModuleDidHide(m: RightSideBarModule) {
        m.wrapperDidHide();
        if (this._isModuleVisible(m)) {
            this.hideContainer();
            this.visibleModule = null;
        }
    }

    protected createViewModel(): BaseViewModel<IRightSideBarProps> {
        return new RightSideBarModel();
    }
}
